import { RouteRecordRaw } from "vue-router";

const userRoutes: RouteRecordRaw[] = [
  {
    path: "/user/password-reset/:token",
    component: () => import("../views/user/PasswordResetView.vue"),
  },
];

export default userRoutes;
